import { Api, HttpClient, IssuanceCardsStatsApi } from '../../../api'
import { Context, PaginatedResult, mapDtoToEntity } from '../../../common'
import { IssuanceCardsStat, IssuanceCardsStatOptions, IssuanceCardsStatsService } from './issuanceCardsStats'

function mapDtoToIssuanceCardsStat(dto: Api.IssuanceCardsStat): IssuanceCardsStat {
  return {
    municipalEntity: mapDtoToEntity({ ...dto.municipalEntity }),
    cardIssuePoint: mapDtoToEntity({ ...dto.cardIssuePoint }),
    values: dto.values,
  }
}

export class RemoteIssuanceCardsStatsService implements IssuanceCardsStatsService {
  private api: IssuanceCardsStatsApi

  constructor(httpClient: HttpClient) {
    this.api = new IssuanceCardsStatsApi(httpClient, undefined, '')
  }

  async formReport(
    ctx: Context,
    opts?: IssuanceCardsStatOptions | undefined,
  ): Promise<{ groupedByCIP: PaginatedResult<IssuanceCardsStat>; groupedByME: IssuanceCardsStat[] }> {
    const result = await this.api.issuanceCardsStatsFormReport(ctx, {
      cardIssuePointId: opts?.filter?.cardIssuePointId,
      municipalEntityId: opts?.filter?.municipalEntityId,
      month: opts?.filter?.month,
      year: opts?.filter?.year,
      aFrom: opts?.paging?.from,
      count: opts?.paging?.count,
    })

    return {
      groupedByCIP: {
        ...result.body.object.groupedByCIP,
        items: result.body.object.groupedByCIP.items.map(mapDtoToIssuanceCardsStat),
      },
      groupedByME: result.body.object.groupedByME.map(mapDtoToIssuanceCardsStat),
    }
  }
}
